import React from 'react';
import { SignInButton } from '@clerk/clerk-react';
import { modalStyles as styles } from './modalStyles';
import { getWarrantyBreakdown } from '../warrantyUtils';

const GREEN = '#46bb89';
const MUTED = '#9ca3af';

function baseLabel(months) {
  if (months % 12 === 0) return `${months / 12}-year`;
  return `${months}-month`;
}

export default function WarrantyModal({ scandate, extraMonths = 0, orgExtraMonths = 0, baseMonths = 36, companyExtraMonths = 0, onClose, isGuestView = false }) {
  if (isGuestView) {
    return (
      <div style={styles.overlay}>
        <div style={{ ...styles.modal, textAlign: 'center', gap: '1rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <h2 style={{ margin: 0 }}>Warranty</h2>
          <p style={{ margin: 0, lineHeight: 1.65 }}>
            Sign in to see the actual warranty status for this device.
          </p>
          <p style={{ margin: 0, lineHeight: 1.65, fontSize: '0.88rem', opacity: 0.75 }}>
            Claiming this device to your company also unlocks 6 months of extra warranty coverage.
          </p>
          <div style={{ display: 'flex', gap: '0.65rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <SignInButton mode="modal">
              <button style={styles.button} onClick={onClose}>Sign in</button>
            </SignInButton>
            <button onClick={onClose} style={styles.buttonAlt}>Close</button>
          </div>
        </div>
      </div>
    );
  }

  const bd = getWarrantyBreakdown(scandate, extraMonths, orgExtraMonths, baseMonths, companyExtraMonths);

  return (
    <div style={styles.overlay}>
      <div style={{ ...styles.modal, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <h2 style={{ margin: 0 }}>Warranty</h2>

        {!bd && (
          <p style={{ margin: 0, color: MUTED }}>Warranty information unavailable.</p>
        )}

        {bd && bd.expired && (
          <p style={{ margin: 0, color: '#f87171' }}>
            Warranty expired {bd.expiredAgo} ago.
          </p>
        )}

        {bd && !bd.expired && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {/* Base warranty row */}
            <div style={{
              padding: '0.65rem 0.85rem',
              borderRadius: '8px',
              background: bd.inBase ? 'rgba(70,187,137,0.08)' : 'rgba(255,255,255,0.04)',
              border: `1px solid ${bd.inBase ? 'rgba(70,187,137,0.3)' : 'rgba(255,255,255,0.1)'}`
            }}>
              <p style={{ margin: '0 0 0.15rem', fontWeight: 600, color: bd.inBase ? GREEN : MUTED, fontSize: '0.88rem' }}>
                {baseLabel((bd.baseMonths || 0) + (bd.companyExtraMonths || 0))} standard warranty
                {bd.companyExtraMonths > 0 ? ` (incl. +${bd.companyExtraMonths} mo company cover)` : ''}
              </p>
              <p style={{ margin: 0, fontSize: '0.85rem', color: MUTED }}>
                {bd.inBase
                  ? <><strong style={{ color: GREEN }}>{bd.baseCountdown} remaining</strong></>
                  : 'Expired — extended warranty active'}
              </p>
            </div>

            {/* Claim extension row */}
            {bd.claimExtraMonths > 0 && (
              <div style={{
                padding: '0.65rem 0.85rem',
                borderRadius: '8px',
                background: bd.inClaim ? 'rgba(70,187,137,0.08)' : 'rgba(255,255,255,0.04)',
                border: `1px solid ${bd.inClaim ? 'rgba(70,187,137,0.3)' : 'rgba(70,187,137,0.15)'}`
              }}>
                <p style={{ margin: '0 0 0.15rem', fontWeight: 600, color: GREEN, fontSize: '0.88rem' }}>
                  +{bd.claimExtraMonths} months extended warranty
                </p>
                <p style={{ margin: 0, fontSize: '0.85rem', color: MUTED }}>
                  {bd.inBase
                    ? `Starts after standard warranty · ${bd.claimCountdown} total remaining`
                    : bd.inClaim
                    ? <><strong style={{ color: GREEN }}>{bd.claimCountdown} remaining</strong></>
                    : 'Expired — special agreement active'}
                </p>
              </div>
            )}

            {/* Org special agreement row */}
            {bd.orgExtraMonths > 0 && (
              <div style={{
                padding: '0.65rem 0.85rem',
                borderRadius: '8px',
                background: bd.inOrg ? 'rgba(70,187,137,0.08)' : 'rgba(255,255,255,0.04)',
                border: `1px solid ${bd.inOrg ? 'rgba(70,187,137,0.3)' : 'rgba(70,187,137,0.15)'}`
              }}>
                <p style={{ margin: '0 0 0.15rem', fontWeight: 600, color: GREEN, fontSize: '0.88rem' }}>
                  +{bd.orgExtraMonths} months — special agreement
                </p>
                <p style={{ margin: 0, fontSize: '0.85rem', color: MUTED }}>
                  {bd.inBase || bd.inClaim
                    ? `Starts after extended warranty · ${bd.totalCountdown} total remaining`
                    : bd.inOrg
                    ? <><strong style={{ color: GREEN }}>{bd.totalCountdown} remaining</strong></>
                    : 'Expired'}
                </p>
              </div>
            )}
          </div>
        )}

        <button onClick={onClose} style={{ ...styles.button, marginTop: '0.25rem' }}>Close</button>
      </div>
    </div>
  );
}
